import dayjs from "dayjs"

export const formatBlogPostDate = (date) => {
  if (!date) return null
  return dayjs(date).format("MMMM D, YYYY")
}

export const blogPostDateInputValue = (date) => {
  if (!date) return ""
  return dayjs(date).format("YYYY-MM-DD")
}
